export async function Login(data: string, uri: string) {
  try {
    const response = await fetch(uri, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: data,
    }).then((resp) =>
      resp
        .json()
        .then((json) => ({ ...json, status: resp.status }))
        .catch(() => ({ status: resp.status })),
    );

    if (response.logged_in || (response.force_redirect && response.redirect_url)) {
      return response;
    }

    throw response;
  } catch (error) {
    if (error.status === 429) {
      return error;
    }

    throw error;
  }
}
